import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const deleteRecording = async ({
  id,
  organisationId,
}: {
  id: string;
  organisationId: string;
}): Promise<void> => {
  const response = await axiosClient.delete(
    `/${organisationId}/recordings/${id}`,
  );
  return response.data;
};

export function useDeleteRecording(
  queryOptions?: UseMutationOptions<
    void,
    HttpError,
    { id: string; organisationId: string }
  >,
) {
  return useMutation({
    mutationFn: ({ id, organisationId }) =>
      deleteRecording({ id, organisationId }),
    ...queryOptions,
  });
}
